import { TaxonomyNavItemIcon } from '@modules/leftNavSidebar/components/icons';
import {
  AdminPanelSettingsRounded,
  DomainRounded,
  LanguageRounded,
  SupervisorAccountRounded,
} from '@mui/icons-material';
import { SettingsMenuSection } from './types';

export const HELP_CENTER_HOW_TO_CONFIGURE_SSO =
  'https://helpcenter.enterpret.com/en/collections/3796955-single-sign-on-sso';

export const HELP_CENTER_HOW_TO_CONFIGURE_SSO_USING_OIDC =
  'https://helpcenter.enterpret.com/en/articles/6870788-okta-enterpret-oidc-sso';

export const HELP_CENTER_HOW_TO_CONFIGURE_SSO_USING_SAML =
  'https://helpcenter.enterpret.com/en/articles/10213826-okta-enterpret-saml-sso';

export const SSO_CONFIGURED_TIMEOUT = 10 * 1000; // 10 seconds

export const WORKSPACE_MENU_SECTIONS_CONFIG_URLS = {
  SSO_SETTINGS: 'sso-settings',
  USERS_PERMISSIONS: 'users-permissions',
  APPROVED_DOMAINS: 'approved-domains',
  TAXONOMY_SETTINGS: 'taxonomy-settings',
  FEEDBACK_TRANSLATIONS: 'feedback-translation',
};

export const WORKSPACE_MENU_SECTIONS: SettingsMenuSection[] = [
  {
    title: 'Access Settings',
    items: [
      {
        icon: <AdminPanelSettingsRounded />,
        text: 'SSO Settings',
        url: WORKSPACE_MENU_SECTIONS_CONFIG_URLS.SSO_SETTINGS,
      },
      {
        icon: <SupervisorAccountRounded />,
        text: 'Users & Permissions',
        url: WORKSPACE_MENU_SECTIONS_CONFIG_URLS.USERS_PERMISSIONS,
      },
      {
        icon: <DomainRounded />,
        text: 'Approved Domains',
        url: WORKSPACE_MENU_SECTIONS_CONFIG_URLS.APPROVED_DOMAINS,
      },
    ],
  },
  {
    title: 'Platform Settings',
    items: [
      {
        icon: <TaxonomyNavItemIcon />,
        text: 'Taxonomy Settings',
        url: WORKSPACE_MENU_SECTIONS_CONFIG_URLS.TAXONOMY_SETTINGS,
      },
      {
        icon: <LanguageRounded />,
        text: 'Feedback Translation',
        url: WORKSPACE_MENU_SECTIONS_CONFIG_URLS.FEEDBACK_TRANSLATIONS,
      },
    ],
  },
];
